(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate','GenericService','Account'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate,GenericService,Account) {
        var vm = this;

        vm.error = null;
        vm.success = null;
        vm.registerAccount = {};
        vm.cities = null;
        vm.registerAgain = registerAgain;
    	vm.departments = null;
        vm.otherDepartment=null;
        vm.designations = null;
        vm.otherDesignation=null;
       
        Account.get().$promise.then(function(response) {			
        	vm.registerAccount = response.data;
        });

        function registerAgain () {
        	GenericService.upadateUserInfo(vm.registerAccount).then(function(response){
                vm.error = null;
                vm.success = 'OK';
                Account.get().$promise.then(function(response) {        			
                	vm.registerAccount = response.data;
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
        
        function getRequiredData(){
        	   GenericService.getSelectBoxData().then( function(data) {		
        		   var cities=[];
					var departments=[];
					var designations=[];
					angular.forEach(data[0],function(row){
						cities.push({
							'cityid':row[0],
							'cityname':row[1]
						});
					});
					vm.cities = cities;
					angular.forEach(data[1],function(row){
						departments.push({
							'departmentid':row[0],
							'departmentname':row[1]
						});
					});
					vm.departments = departments;
					angular.forEach(data[2],function(row){
						designations.push({
							'designationid':row[0],
							'designationname':row[1]
						});
					});
					vm.designations = designations;
        });
        }
        getRequiredData();
    }
})();
